import { DatePicker } from "@/components/ui/date-picker-input"
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from "@/components/ui/form"
import { cn } from "@/lib/utils"
import { Path, UseFormReturn } from "react-hook-form"
import { z } from "zod"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DatePickerInputField = <Tschema extends z.ZodType<any, any, any>>({
  form,
  name,
  description,
  label,
  isDisabled,
  className,
  required = false,
  calendarMinDate,
  calendarMaxDate
}: {
  form: UseFormReturn<z.infer<Tschema>>,
  schema: Tschema,
  name: Path<z.TypeOf<Tschema>>,
  description?: string,
  label: string,
  isDisabled: boolean,
  className?: string
  required?: boolean
  calendarMinDate?: Date
  calendarMaxDate?: Date
}
) => {
  const inputFieldClassName = cn('w-[400px] bg-foreground text-primary ', className)
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel
            className={cn('flex justify-start font-semibold text-primary !text-sm', `${!description ? 'mb-1' : ''}`)}
            isRequired={required}
          >
            {label}
          </FormLabel>
          {description && <p className="text-secondary text-sm font-normal !-mt-1 mb-1 text-left">{description}</p>}
          <DatePicker
            date={field.value}
            setDate={field.onChange}
            isDisabled={isDisabled}
            className={inputFieldClassName}
            calendarMinDate={calendarMinDate}
            calendarMaxDate={calendarMaxDate}
          />
          <FormMessage
            showIcon={true}
            className="flex flex-row justify-start"
          />
        </FormItem>
      )}
    />
  )
}
